import "./inventoryprofileheader.scss";

const InventoryProfileHeader = ({ status, itemName, itemBarcode }: any) => {
  return (
    <div className="inventory-profile-header-wrapper">
      <div className="inventory-title-status-box">
        <div className="inventory-name-barcode">
          <h2>{itemName}</h2>
          {itemBarcode && <span className="item-barcode">{itemBarcode}</span>}
        </div>
        <div
          className={`status-box
          ${status ? "active" : "inactive"}`}
        >
          <span className="status-circle"></span>
          <span className="status-text">{status ? "Active" : "Inactive"}</span>
        </div>
      </div>
    </div>
  );
};

export default InventoryProfileHeader;
